import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import api from './services/api'
// Full Vuetify component CSS. This app builds Vuetify a-la-carte
// (vuetify/lib/framework) and relied on vuetify-loader treeshaking, which left
// list/component styles out of the bundle — so the sidebar nav rendered
// unstyled once enterprise-tokens' global reset stripped fallback spacing.
// Importing the full stylesheet guarantees all component styles are present.
// Load BEFORE enterprise-tokens so the design tokens/overrides layer on top.
import 'vuetify/dist/vuetify.min.css'
import './styles/enterprise-tokens.css'
import './assets/css/glassy-theme.css'
import actionProcessDirective from './directives/action-process.js'
import { formatCurrency, formatPercentage, formatDecimal } from './utils/numberFormat'

Vue.config.productionTip = false

Vue.directive('action-process', actionProcessDirective);

Vue.filter('currency', formatCurrency);
Vue.filter('percentage', formatPercentage);
Vue.filter('decimal', formatDecimal);

new Vue({
  router,
  store,
  vuetify,
  async created () {
    // Handle SSO callback token before auth check
    const params = new URLSearchParams(window.location.search);
    const callbackToken = params.get('token');
    
    if (callbackToken) {
      localStorage.setItem('access_token', callbackToken);
      // Clean the URL
      window.history.replaceState({}, '', '/');
    }

    const token = localStorage.getItem('access_token');
    if (token) {
      store.commit('setUserLoading', true);
      const user = await api.auth.getMe();
      if (user) {
        store.commit('SET_LOGGED_IN', true);
        await store.dispatch('getUser', user);
      } else {
        localStorage.removeItem('access_token');
        store.commit('SET_LOGGED_IN', false);
        store.commit('SET_USER', null);
      }
      store.commit('setUserLoading', false);
    }
  },
  render: h => h(App)
}).$mount('#app')